module.exports = __webpack_public_path__ + "img/successfactors.cb7db048.svg";